import React from 'react';

const CARD_TEXT_TAGS = {
    black: 'card-text-tag-black',
    pink: 'card-text-tag-pink',
    blue: 'card-text-tag-blue',
    grey: 'card-text-tag-grey',
    red: 'card-text-tag-red',
    green: 'card-text-tag-green',
    white: 'card-text-tag-white',
    argument: 'card-text-tag-argument'
};

const TAG_NAMES = Object.keys(CARD_TEXT_TAGS).join('|');

function findClosingTag(text, tagName, startIndex) {
    const tagPattern = new RegExp(`</?${tagName}>`, 'gi');
    tagPattern.lastIndex = startIndex;

    let depth = 1;
    let match;

    while ((match = tagPattern.exec(text)) !== null) {
        const isClosingTag = match[0][1] === '/';

        if (isClosingTag) {
            depth -= 1;
        } else {
            depth += 1;
        }

        if (depth === 0) {
            return match.index;
        }
    }

    return -1;
}

export function formatCardText(text, keyPrefix = 'card-text') {
    if (typeof text !== 'string') {
        return text;
    }

    const tagPattern = new RegExp(`</?(${TAG_NAMES})>`, 'gi');
    const parts = [];
    let cursor = 0;
    let match;

    while ((match = tagPattern.exec(text)) !== null) {
        const fullTag = match[0];
        const tagName = match[1].toLowerCase();
        const isClosingTag = fullTag[1] === '/';

        if (isClosingTag) {
            continue;
        }

        const contentStart = tagPattern.lastIndex;
        const contentEnd = findClosingTag(text, tagName, contentStart);

        if (contentEnd === -1) {
            continue;
        }

        if (match.index > cursor) {
            parts.push(text.slice(cursor, match.index));
        }

        parts.push(
            <span className={`card-text-tag ${CARD_TEXT_TAGS[tagName]}`} key={`${keyPrefix}-${match.index}-${tagName}`}>
                {formatCardText(text.slice(contentStart, contentEnd), `${keyPrefix}-${match.index}-${tagName}`)}
            </span>
        );

        cursor = contentEnd + tagName.length + 3;
        tagPattern.lastIndex = cursor;
    }

    if (cursor < text.length) {
        parts.push(text.slice(cursor));
    }

    return parts;
}

export function CardText({ children }) {
    return formatCardText(children);
}
